// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"3cd43fb4","338":"60b9bc7c","453":"ffdcaf2d","484":"6f13d47b","551":"44d89a0d","645":"c578db00"}[chunkId] + ".chunk.js";
};